import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { MatSnackBar,MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { AssignmentDialogService } from 'src/app/shared/services/assignment-dialog.service';
import { AssignmentService } from 'src/app/shared/services/assignment.service';
import { DownloadService } from 'src/app/shared/services/download.service';
import { NavbarService } from 'src/app/shared/services/navbar.service';
import { UserService } from 'src/app/shared/services/user.service';
import { Utils } from 'src/app/shared/utils/utils';
import {IWGSharedService} from 'src/app/shared/services/shared.service';
import { QuotesDialogComponent } from '../../quotes/quotes-dialog/quotes-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-assignment-detail',
  templateUrl: './assignment-detail.component.html',
  styleUrls: ['./assignment-detail.component.scss']
})
export class AssignmentDetailComponent implements OnInit {
    
@HostListener('window:beforeunload', ['$event'])
public onPageUnload($event: CloseEvent) {       
    if (this.sharedService.getAssignmentQuestionDirty()) {
        $event.returnValue=false;
    }        
}
  constructor(public router: Router, private utils: Utils, public userService: UserService,
              private sharedService: IWGSharedService,
              private assignmentService: AssignmentService, private nav: NavbarService, 
              private downloadService: DownloadService, private route: ActivatedRoute,private toast:MatSnackBar,
      private assignmentDialogService: AssignmentDialogService, public dialog: MatDialog
              ) {}
  Hposition:MatSnackBarHorizontalPosition = "right";
  VPosition:MatSnackBarVerticalPosition = "top";
  Role:any
  selectedService = 1;
  selectedServiceName: string;
  ShowEOREstimator = false;
  AORDisabled=false;
  assignmentLabel = '';
  assignmentLabelPlural = '';
  ShowQuotesButton = false;
  showCompliance=false;
  sub: any;
  assignment: any;
  existingAssignmentId:any;
  assignmentId: number;
  state: any = {};
  loading = false;
  props:any;
  IsManagerQuestionnaireEdit = false;
  IsContractorQuestionnaireEdit = false;
  AssignmentDisplayId = null;
  AssignmentStatusId = 0;
  ContractorName = null;
  BussinessName = null;
  selectedTabIndex = 0;
  ShowQuestionnaire = false;
  ShowDocuments = false;
  ShowCreateInvoice = false;
  isSubmit:boolean = false;

  jobLabel = '';
  jobTitleLabel = '';
  workerLabel = '';
  jobDescriptionLabel = '';
  SOWFileID = '';
  activeiconcolor = '';
  defaultParam:any;

  EORDisabled = false;
  ComplianceDisabled = false;

  ShowEORQuotes = true;
  ShowComplianceQuotes = true;
    ShowAORQuotes = true;
    showFooter = true;
    embedStatus = "notembed";  
  
  ngOnInit(): void {

    var isEmbed = this.sharedService.getIsEmbed();
      if (isEmbed === true) {
          this.embedStatus = "embed";
          this.nav.show(isEmbed);
          history.pushState(null, null, null);
          window.addEventListener('popstate', () => {
              history.pushState(null, null, null);
          });
          this.showFooter = false;
      } else {
          this.nav.show();
          this.nav.setActiveMenu('services');
          this.showFooter = true;
      }

    this.route.params.subscribe(params => {
        this.assignmentId = params.assignmentId;
      });

    this.route.queryParams.subscribe(params => {
    this.defaultParam=params;
      this.selectedService = +params.service;
      this.state = Object.assign({}, this.state, params);     
      if (!this.state.service) {
        this.state.service = 1;
      }
    });

    this.selectedServiceName = this.utils.getServiceName(this.selectedService);
    this.ShowEOREstimator = this.userService.getShowEOREstimator();
    this.AORDisabled = this.userService.getAORDisabled();
    this.ShowQuotesButton = !this.userService.getNewQuotesDisabled();
    this.showCompliance = !this.userService.getEvaluateButtonDisabled();
    this.Role=this.userService.getRole();
    if (this.Role == 'Worker' && this.AORDisabled) {
      this.ShowCreateInvoice = true;
    }
    if(this.userService.getRole() == 'Worker') {
        this.ShowEORQuotes = false;
        this.ShowComplianceQuotes = false;
        this.ShowAORQuotes = false;
    }
    if (this.selectedServiceName === 'Employer of Record') {
      this.assignmentLabel = 'Assignment';
      this.jobLabel = 'Job';
      this.jobTitleLabel = 'Job Title';
      this.workerLabel = 'Worker';
      this.jobDescriptionLabel = 'Job Description';
  }
  else if (this.selectedServiceName === 'Agent of Record') {
      this.assignmentLabel = 'Engagement';
      this.jobLabel = 'Service';
      this.jobTitleLabel = 'Service Type';
      this.workerLabel = 'Contractor';
      this.jobDescriptionLabel = 'Project Description';
  }
  else if (this.selectedServiceName === 'Compliance') {
      this.assignmentLabel = 'Evaluation';
      this.jobLabel = 'Service';
      this.jobTitleLabel = 'Service Type';
      this.workerLabel = 'Contractor';
      this.jobDescriptionLabel = 'Project Description';
  }
    this.assignmentLabelPlural = this.assignmentLabel + 's';
    this.getAssignment();

    this.EORDisabled = this.userService.getEORDisabled();
    this.ComplianceDisabled = this.userService.getComplianceDisabled();

    this.sharedService.assignmentStatusChange.subscribe((data) => { 
             
        this.getAssignment();
    });
  }
     
  onTabChanged($event): void {
  }

  getAssignment = (noLimit = false) => {
    this.loading = true;
    const datePipe = new DatePipe('en-US');

    const defaultParams = {
      limit: 250,
      start: datePipe.transform(this.state.start, 'yyyy-MM-dd'),
      end: datePipe.transform(this.state.end, 'yyyy-MM-dd'),
      global_scope: this.state.global_scope,
      service: this.state.service,
      q: this.state.q,
    };

   

    this.assignmentService.getAssignmentById(this.assignmentId).pipe(catchError((err) => {
      console.log('There was an error getting data in component', err);
      throw (err);
    }))
      .subscribe(result => {
        if (result.apiCallStatus && result.data.Data) {           
          this.loading = false;
          this.assignment = result.data.Data;
          this.SOWFileID = this.assignment.SOWFile.ID;
          this.existingAssignmentId = this.assignment.ID;        
          if (this.state.service == 3) {
            if ((this.assignment.Status.ID == 10 && this.Role != 'Worker') || (this.assignment.Status.ID == 13 && this.Role == 'Worker')) {
              this.selectedTabIndex = 1
          }
          if ((this.assignment.Status.ID == 14 && this.Role == 'Worker')) {
            this.selectedTabIndex = 2
        }
          if (((this.Role != 'Worker' && this.assignment.Status.ID >= 9) || (this.Role == 'Worker' && (this.assignment.Status.ID >= 13 || this.assignment.Status.ID == 9))) && this.assignment.Status.ID <= 15) {                
            this.ShowQuestionnaire = this.assignment.EvaluationQuestions && this.assignment.EvaluationQuestions.length > 0;
        }
        this.IsManagerQuestionnaireEdit = this.assignment.Status.ID == 10 && this.Role != 'Worker';
        this.IsContractorQuestionnaireEdit = this.assignment.Status.ID == 13 && this.Role == 'Worker';
    
        if (this.Role === 'Worker' && this.ShowQuestionnaire === true && (this.assignment.Status.ID > 13 || this.assignment.Status.ID === 9)) {
          this.AssignmentDisplayId = this.assignment.DisplayID;
          this.ContractorName = this.assignment.Worker.Name;
          this.AssignmentStatusId = this.assignment.Status.ID;
          this.BussinessName = this.assignment.WorkerCompanyName;
          this.ShowDocuments = true;
         
      }
      const self=this;
      this.assignment.EvaluationQuestions.forEach(function (qitem, qkey) {
        self.assignment.EvaluationAnswers.forEach(function (aitem, akey) {
            if (aitem.Anwser != '' && aitem.Anwser != null) {
                if (((self.Role == 'Worker' && aitem.QuestionnaireType == 2) || (self.Role != 'Worker' && aitem.QuestionnaireType == 1)) && aitem.Status) {
                    if (qitem.QuestionFieldTypeID == 4 && qitem.QuestionID == aitem.QuestionID) {
                        qitem['AnswerList'] = aitem.Anwser.split('|');
                        qitem.IsShow = true;
                    } else if (qitem.QuestionID == aitem.QuestionID) {
                        qitem.Answer = aitem.Anwser;
                        qitem.IsShow = true;
                    }
                }
            }
        });
    
        if (qitem.ParentQuestionID != null) {
          self.assignment.EvaluationQuestions.forEach(function (item, key) {
                if (qitem.ParentQuestionID == item.QuestionID) {
                    if (item.QuestionFieldTypeID == 4 && item.AnswerList && item.AnswerList.length > 0) {
                        var optionName = '';
                        item.AnswerList.forEach(function (qaitem, key) {
                            item.QuestionOptions.forEach(function (oitem, key) {
                                if (oitem.FieldOption == qaitem && qitem.ParentVisibilityCriteria == oitem.OptionID) {
                                    optionName = oitem.OptionID
                                }
                            });
                        });
                        if (optionName != '' && qitem.ParentVisibilityCriteria == optionName) {
                            qitem['IsShow'] = true;
                        } else {
                            qitem['IsShow'] = false;
                        }
                    } else if (item.QuestionFieldTypeID != 3) {
                        var optionName = '';
                        item.QuestionOptions.forEach(function (oitem, key) {
                            if (oitem.FieldOption == item.Answer) { optionName = oitem.OptionID }
                        });
                        if (optionName != '' && qitem.ParentVisibilityCriteria == optionName) {
                            qitem['IsShow'] = true;
                        } else {
                            qitem['IsShow'] = false;
                        }
                    }
                }
            });
        }
    });

          }
        }
        this.loading = false;
      },
        error => {
          this.loading = false;
          console.log(error);
        });
  }

  downloadOfferLetterFile(): void {
      this.loading = true;
      this.downloadService.saveAs('/Api/File/' + this.assignment.OfferLetterFile.ID).then (res=> {
        this.loading = false;
      });
  }

  downloadSOWFile(): void {
    this.loading = true;
    this.downloadService.saveAs('/Api/File/' + this.SOWFileID).then (res=> {
      this.loading = false;
    });
  }

  downloadJobDescriptionFile(): void {
    this.loading = true;
    this.downloadService.saveAs('/Api/File/' + this.assignment.JobDescriptionFile.ID).then (res=> {
      this.loading = false;
    });
  }
  QuestionParentFilter(ques) {
    return ques.ParentQuestionID == null && (this.Role == 'Worker' ?
        ques.ContractorDescription != null && ques.ContractorDescription != ''
        : ques.ManagerDescription != null && ques.ManagerDescription != '');
  };
  QuestionChildFilter(parentQues,childQues) {
        return (childQues.QuestionID == parentQues.QuestionID || childQues.ParentQuestionID == parentQues.QuestionID)
            && (this.Role == 'Worker' ? childQues.ContractorDescription != null && childQues.ContractorDescription != ''
                : childQues.ManagerDescription != null && childQues.ManagerDescription != '');
  };
  
save(isSubmitQues) {
  this.loading = true;
  this.isSubmit = isSubmitQues;

  let props = {};
  var evaluationQuestions = [];

  var isValid = true;
  if (isSubmitQues) {
      const self=this;
      this.assignment.EvaluationQuestions.forEach(function (item, key) {
          if (item.QuestionFieldTypeID == 4 && item.AnswerList && item.AnswerList.length > 0) {
              var answerOptions = [];
              item.AnswerList.forEach(function (anss, akey) {
                  item.QuestionOptions.forEach(function (qatem, qakey) {
                      if (qatem.FieldOption == anss) { answerOptions.push(qatem.FieldOption); }
                  });
              });

              item.AnswerList = answerOptions;
          } else if (item.QuestionFieldTypeID != 3 && item.Answer != null && item.Answer != '') {
              var answerOption = '';
              item.QuestionOptions.forEach(function (qatem, qakey) {
                  if (qatem.FieldOption == item.Answer) { answerOption = qatem.FieldOption }
              });

              item.Answer = answerOption;
          }
          
          if ((self.IsManagerQuestionnaireEdit && item.ManagerDescription != null && item.ManagerDescription != '') || (self.IsContractorQuestionnaireEdit && item.ContractorDescription != null && item.ContractorDescription != '')) {
              if (item.ParentQuestionID != null) {
                self.assignment.EvaluationQuestions.forEach(function (itemChild, key) {
                      if (itemChild.QuestionID == item.ParentQuestionID) {
                          itemChild.QuestionOptions.forEach(function (itemOptions, key) {
                              if (itemOptions.OptionID == item.ParentVisibilityCriteria && ((itemChild.QuestionFieldTypeID != 4 && itemChild.Answer == itemOptions.FieldOption) || (itemChild.QuestionFieldTypeID == 4 && itemChild.AnswerList && itemChild.AnswerList.indexOf(itemOptions.FieldOption) != -1))) {
                                  if (!(self.ValidateString(item.Answer)) && !(self.ValidateString(item.AnswerList))) { //To validate the Answer and AnswerList, if any one has value consider as true
                                      item.ShowValidation = true;
                                      isValid = false;
                                  } else {
                                      item.ShowValidation = false;
                                  }
                              }
                          });
                      }
                  });
              } else {
                  if (!(self.ValidateString(item.Answer)) && !(self.ValidateString(item.AnswerList))) { //To validate the Answer and AnswerList, if any one has value consider as true
                      item.ShowValidation = true;
                      isValid = false;
                  } else {
                      item.ShowValidation = false;
                  }
              }
          }
      });

      if (!isValid) {
          alert('Please provide answers for all questions prior to submitting the questionnaire.');
          var response = { Validation: false };
          return this.onValidationError(response);
      }
  }

const self=this;

self.assignment.EvaluationQuestions.forEach(function (item, key) {
      if (((item.Answer != null && item.Answer != '') || (item.QuestionFieldTypeID == 4 && item.AnswerList && item.AnswerList.length > 0))
          && ((self.IsManagerQuestionnaireEdit && item.ManagerQuestionnaire) || (self.IsContractorQuestionnaireEdit && item.ContractorQuestionnaire))) {
          var obj = {};
          obj['QuestionID'] = item.QuestionID;
          obj['QuestionLogID'] = item.QuestionLogID;
          obj['QuestionnaireType'] = self.IsManagerQuestionnaireEdit ? 1 : self.IsContractorQuestionnaireEdit ? 2 : 0;//By Default manager
          if (item.QuestionFieldTypeID == 4 && item.AnswerList && item.AnswerList.length > 0) {
              var answers = [];
              item.QuestionOptions.forEach(function (itemOptions, key) {
                  item.AnswerList.forEach(function (answerOptions, key) {
                      if (answerOptions == itemOptions.FieldOption) {
                          answers.push(answerOptions);
                      }
                  });
              });
              item.Answer = answers.join('|');
          }
          obj['Anwser'] = item.Answer;
          evaluationQuestions.push(obj);
      }
  });

  var evaluationStatusID = 0;
  if (this.IsManagerQuestionnaireEdit) {
      evaluationStatusID = isSubmitQues ? 11 : 10;
  } else if (this.IsContractorQuestionnaireEdit) {
      evaluationStatusID = isSubmitQues ? 14 : 13;
  }

  this.props={
    evaluationquestions: JSON.stringify(evaluationQuestions),
    evaluationquestions_status_id: evaluationStatusID,
    request_from_client_portal: true
  }
  if (this.existingAssignmentId) {
   

    return this.assignmentService.update(this.existingAssignmentId, this.props)
    .toPromise()
    .then(data => {this.onSaveSuccess(data); return data; })
    .catch(err => this.onSaveError(err));
  } else {
     // if (!this.sharedService.getIsEmbed()) {
          this.router.navigate(["assignments"], { queryParams: { service: 3, global_scope: this.defaultParam.global_scope } })
     // }
  }

}
    onSaveSuccess(response) {
        this.loading = false;
        this.existingAssignmentId = response.data.Data.ID;
        if (response.data.ErrorCode != 200) {
            this.showConfirmationToast('Error while submitting evaluation questionnaire.');
        } else {
            if (this.isSubmit) {
                this.showConfirmationToast('Evaluation questionnaire submitted successfully.');
            } else {
                this.showConfirmationToast('Draft has been saved.');
            }
        } //if (!this.sharedService.getIsEmbed()) {
            this.router.navigate(["assignments"], { queryParams: { service: 3, global_scope: this.defaultParam.global_scope } })
       // }
    }
onSaveError(error){
    this.loading = false;
  }
ValidateString(currentStr) {
  if (currentStr == null || currentStr == '' || currentStr == undefined) {
      return false;
  }
  return true;
}
onValidationError(response) {
  this.loading = false;
}
onQuestionOptionChange = (ques, option) => {
  if (ques.QuestionFieldTypeID == 4) {
      if (ques.AnswerList) {
          if (ques.AnswerList.indexOf(option.FieldOption) >= 0) {
              ques.AnswerList.splice(ques.AnswerList.indexOf(option.FieldOption), 1)
          } else {
              ques.AnswerList.push(option.FieldOption);
          }
      } else {
          ques['AnswerList'] = [];
          ques.AnswerList.push(option.FieldOption);
      }

      if (ques.ParentQuestionID == null) {
          var optionName = [];
          ques.QuestionOptions.forEach(function (item, key) {
              ques.AnswerList.forEach(function (anss, akey) {
                  if (item.FieldOption == anss) { optionName.push(item.OptionID); }
              });
          })
          this.assignment.EvaluationQuestions.forEach(function (item, key) {
              if (item.ParentQuestionID == ques.QuestionID) {
                  if (optionName.indexOf(item.ParentVisibilityCriteria) >= 0) {
                      item['IsShow'] = true;
                  } else {
                      item['IsShow'] = false;
                      item.Answer = null;
                      item['AnswerList'] = [];
                  }
              }
          });
      }     
  } else if (ques.ParentQuestionID == null && ques.QuestionFieldTypeID != 3) {
      let optionName = '';
      ques.QuestionOptions.forEach(function (item, key) {
          if (item.FieldOption == ques.Answer) { optionName = item.OptionID }
      })
      this.assignment.EvaluationQuestions.forEach(function (item, key) {
          if (item.ParentQuestionID == ques.QuestionID) {
              if (item.ParentVisibilityCriteria == optionName) {
                  item['IsShow'] = true;
              } else {
                  item['IsShow'] = false;
                  item.Answer = null;
                  item['AnswerList'] = [];
              }
          }
      });
  }
  this.sharedService.setAssignmentQuestionDirty(true);      
};
textAreaChange = () =>{
    this.sharedService.setAssignmentQuestionDirty(true);      
}
isConfirm() {
    return confirm('Are you sure you want to leave the page without submitting?');
  }
OnClickAssignments(service){
    if (this.sharedService.getAssignmentQuestionDirty()) {
      if (this.isConfirm()) {
          this.sharedService.setAssignmentQuestionDirty(false);
          this.router.navigate(['/assignments'], { queryParams: { service: service } });    
      }
    } else {
        this.router.navigate(['/assignments'], { queryParams: { service: service } });    
    }
  }
  OnClickQuote(service){
    if (this.sharedService.getAssignmentQuestionDirty()) {
      if (this.isConfirm()) {
          this.sharedService.setAssignmentQuestionDirty(false);
          this.router.navigate(['/quotes'], { queryParams: { service: service } });    
      }
    } else {       
        this.router.navigate(['/quotes'], { queryParams: { service: service } });    
    }
    }

    OnClickQuoteEstimator() {
        if (this.sharedService.getAssignmentQuestionDirty()) {
            if (this.isConfirm()) {
                this.sharedService.setAssignmentQuestionDirty(false);
                this.router.navigate(['/quoteEstimator/7b57522b-d0d6-403c-b524-1f0e2f24003c'], { queryParams: { service: 1, global_scope: 2 } });
            }
        } else {
            this.router.navigate(['/quoteEstimator/7b57522b-d0d6-403c-b524-1f0e2f24003c'], { queryParams: { service: 1, global_scope: 2 } });
        }
    }

    SaveDraftQuestions() {
        this.sharedService.setAssignmentQuestionDirty(false);
return this.save(false);
}
isQuestionChecked(ques, option) {
    return ques.AnswerList && ques.AnswerList.indexOf(option.FieldOption) >= 0;
};
    SubmitQuestions() {
        this.sharedService.setAssignmentQuestionDirty(false);
    return this.save(true);
}
showConfirmationToast(text){
    this.toast.open(text, "Got it", {
      duration: 2000,horizontalPosition:this.Hposition,
      verticalPosition:this.VPosition,
      panelClass: 'iwg-toast-text-white',
    });
  }

    showEditAssignmentDialog = (ev, assignmentId) => {
        this.assignmentDialogService.show(ev, assignmentId, null, null, null, null, false, true, true);
    }
    
    getOnboardingCount = (taskListArray, type) => {
        
        if (taskListArray) {
            if (type == 1) {
                return taskListArray.filter(e => e.StatusDescription == 'Complete').length;
            } else {
                return taskListArray.length;
            }
        }
        return 0;
    }

    showAssignmentDialog = (ev, quoteId, serviceId) => {
        this.assignmentDialogService.show(ev, null, quoteId, null, null, serviceId);
    }
    ShowQuoteDialog_embed = (ev) => {
        this.displayQuoteDialog(ev);
    }

    displayQuoteDialog = (ev) => {
        this.sharedService.isBlurredBg.next(true);
        const dialogRef = this.dialog.open(QuotesDialogComponent, {
            panelClass: 'iwg-form-dialogfull',
            autoFocus: false,
            data: { existingQuote: null }
        });
        dialogRef.afterClosed().subscribe(result => {
            this.sharedService.isBlurredBg.next(false);
        });
    }
}
